import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function filterReducer(state = initialState.filter, action) {
  if (action.type === types.LOAD_FILTER_DATA_SUCCESS) {
    return action.filter;
  }
  return state;
}
